import { render, staticRenderFns } from "./BuyOrder.vue?vue&type=template&id=32319af9&scoped=true&"
import script from "./BuyOrder.vue?vue&type=script&lang=js&"
export * from "./BuyOrder.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrder.vue?vue&type=style&index=0&id=32319af9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32319af9",
  null
  
)

export default component.exports